import React from 'react'
import PropTypes from 'prop-types'

// @ts-ignore
import DisabilityCheckboxField from '../DisabilityCheckboxField'
import Layout from './Layout'
import container from './container'

const WrapInDisabilityCheckboxField = ({
  WrappedComponent,
  wrappedCmpProps,
  disCbFldProps,
  wrappedCmpsShareOfWidth,
  disabled,
  checkboxDisabled,
}) => (
  <Layout wrappedCmpsShareOfWidth={wrappedCmpsShareOfWidth}>
    <DisabilityCheckboxField {...disCbFldProps} checkboxDisabled={checkboxDisabled} disabled={disabled} />
    <WrappedComponent {...wrappedCmpProps} disabled={disabled || checkboxDisabled} />
  </Layout>
)

WrapInDisabilityCheckboxField.defaultProps = {
  disabled: false,
}

WrapInDisabilityCheckboxField.propTypes = {
  disabled: PropTypes.bool,
}

export default container(WrapInDisabilityCheckboxField)
